/**
 * Page template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import News from './partials/News';
import VideoBlock from './partials/VideoBlock';
import Faculty from './partials/Faculty';
import Faq from './partials/Faq';
import ContactForm from './partials/ContactForm';
import ThankYou from './partials/ThankYou';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Page';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
  Logger.info(`${NAME} > init`);

  const newsDom = document.querySelector('.news');
  if (newsDom) new News(newsDom).init();

  const videoDom = document.querySelector('.video-block');
  if (videoDom) new VideoBlock(videoDom).init();

  const facultyDom = document.querySelector('.faculty');
  if (facultyDom) new Faculty(facultyDom).init();

  const faqDom = document.querySelector('.faq');
  if (faqDom) new Faq(faqDom).init();

  document.querySelectorAll('.contact-form').forEach((dom) => new ContactForm(dom).init());

  const thankYouDom = document.querySelector('section.thank-you');
  if (thankYouDom) new ThankYou(thankYouDom).init();
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
